import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './global.css';
import { AuthenticationProvider } from './hooks/useAuthentication.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AuthenticationProvider>
    <App />
  </AuthenticationProvider>,
);
